<div class="modal-overlay" (click)="onBackdropClick()">
  <div class="modal-container" (click)="$event.stopPropagation()">
    <!-- Header with integrated countdown -->
    <div class="modal-header">
      <div class="modal-header-title">
        <div class="modal-icon primary">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
            <line x1="16" y1="2" x2="16" y2="6"></line>
            <line x1="8" y1="2" x2="8" y2="6"></line>
            <line x1="3" y1="10" x2="21" y2="10"></line>
          </svg>
        </div>
        <h2 class="modal-title">
          @switch (step()) {
            @case ('players') { Mitspieler auswählen }
            @case ('preview') { Buchung prüfen }
            @case ('payment') { Zahlung }
            @case ('success') { Buchung erfolgreich }
          }
        </h2>
      </div>
      <div class="header-right">
        @if (step() !== 'success') {
          <div class="countdown-badge" [ngClass]="getTimerClass()">
            <svg class="countdown-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="10"></circle>
              <polyline points="12 6 12 12 16 14"></polyline>
            </svg>
            <span class="countdown-text">{{ countdownDisplay }}</span>
          </div>
        }
        <button type="button" class="close-btn" aria-label="Schließen" (click)="step() === 'success' ? bookAnother() : onCancel()">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
      </div>
    </div>

    <!-- Step Indicator (hidden on success) -->
    @if (step() !== 'success') {
      <div class="step-indicator">
        <!-- Step 1: Players (conditional) -->
        @if (showPlayersStep()) {
          <div class="step"
               [class.active]="step() === 'players'"
               [class.completed]="step() !== 'players'">
            <span class="step-number">1</span>
            <span class="step-label">Spieler</span>
          </div>
          <div class="step-line" [class.completed]="step() !== 'players'"></div>
        }

        <!-- Step 2: Preview -->
        <div class="step"
             [class.active]="step() === 'preview'"
             [class.completed]="step() === 'payment' || step() === 'success'">
          <span class="step-number">{{ showPlayersStep() ? 2 : 1 }}</span>
          <span class="step-label">Vorschau</span>
        </div>
        <div class="step-line" [class.completed]="step() === 'payment' || step() === 'success'"></div>

        <!-- Step 3: Payment -->
        <div class="step"
             [class.active]="step() === 'payment'"
             [class.completed]="step() === 'success'">
          <span class="step-number">{{ showPlayersStep() ? 3 : 2 }}</span>
          <span class="step-label">Zahlung</span>
        </div>
      </div>
    }

    <!-- Court loading state -->
    @if (courtLoading && step() !== 'success') {
      <div class="loading-inline">
        <span class="spinner-small"></span>
        <span>Verfügbarer Platz wird gesucht...</span>
      </div>
    }

    <!-- Alternative court notification -->
    @if (alternativeCourtSelected && step() !== 'success') {
      <div class="alternative-court-notification">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="10"></circle>
          <line x1="12" y1="16" x2="12" y2="12"></line>
          <line x1="12" y1="8" x2="12.01" y2="8"></line>
        </svg>
        <span>Der gewählte Platz wurde soeben gebucht. Wir haben einen alternativen Platz für Sie reserviert.</span>
      </div>
    }

    <!-- ============================================================================
         STEP 1: Players Selection
         ============================================================================ -->
    @if (step() === 'players') {
      <div class="modal-content">
        <!-- Compact slot summary -->
        @if (heldSlot) {
          <div class="session-summary">
            <div class="summary-row">
              <span class="summary-label">Platz</span>
              <span class="summary-value">{{ heldSlot.category.name }}: {{ heldSlot.court.name }}</span>
            </div>
            <div class="summary-row">
              <span class="summary-label">Datum</span>
              <span class="summary-value">{{ heldSlot.date | date:'EEEE, d. MMMM' }}</span>
            </div>
            <div class="summary-row">
              <span class="summary-label">Uhrzeit</span>
              <span class="summary-value">{{ formatTime(heldSlot.startTime) }} · {{ heldSlot.durationMinutes }} Min</span>
            </div>
          </div>
        }

        <!-- Player selector / search (with optional slots visualization) -->
        <div class="players-section">
          <h3>{{ isPricingPerPlayerEnabled() ? 'Gast durch Spieler ersetzen' : 'Mitspieler hinzufügen' }}</h3>
          <app-player-selector
            [organizationId]="getOrganizationId() || ''"
            [minPlayers]="getMinPlayers()"
            [maxPlayers]="getMaxPlayers()"
            [initialPlayers]="selectedPlayers"
            [showSlots]="isPricingPerPlayerEnabled()"
            [guestAllowance]="guestAllowanceHint"
            [organizerName]="getCurrentUser()?.username || 'Du'"
            (playersChanged)="onPlayersChanged($event)"
            (guestSlotCountChanged)="onGuestSlotCountChanged($event)">
          </app-player-selector>
        </div>

        <!-- Error message -->
        @if (bookingError) {
          <div class="error-message">
            {{ bookingError }}
          </div>
        }
      </div>

      <!-- Players Step Actions -->
      <div class="modal-actions">
        <button type="button" class="btn btn-ghost" (click)="onCancel()">Abbrechen</button>
        <button type="button" class="btn btn-primary"
                [disabled]="!canProceedFromPlayers()"
                (click)="goToPreview()">
          Weiter zur Vorschau
          <app-icon [type]="IconType.CHEVRON_RIGHT" [size]="18"></app-icon>
        </button>
      </div>
    }

    <!-- ============================================================================
         STEP 2: Preview + Vouchers
         ============================================================================ -->
    @if (step() === 'preview') {
      <div class="modal-content">
        <!-- Full booking details -->
        @if (heldSlot) {
          <div class="session-summary">
            <div class="summary-row">
              <span class="summary-label">Platz</span>
              <span class="summary-value">{{ heldSlot.category.name }}: {{ heldSlot.court.name }}</span>
            </div>
            <div class="summary-row">
              <span class="summary-label">Datum</span>
              <span class="summary-value">{{ heldSlot.date | date:'EEEE, d. MMMM' }}</span>
            </div>
            <div class="summary-row">
              <span class="summary-label">Uhrzeit</span>
              <span class="summary-value">{{ formatTime(heldSlot.startTime) }}</span>
            </div>
            <div class="summary-row">
              <span class="summary-label">Dauer</span>
              <span class="summary-value">{{ heldSlot.durationMinutes }} Minuten</span>
            </div>
            @if (!isPricingPerPlayerEnabled()) {
              <div class="summary-row">
                <span class="summary-label">Preis</span>
                <span class="summary-value price-highlight">{{ heldSlot.price | currency:'EUR':'symbol':'1.2' }}</span>
              </div>
            }

            <!-- Selected players summary (shown when NO price breakdown available) -->
            @if (selectedPlayers.length > 0 && !multiPlayerPricePreview) {
              <div class="players-summary">
                <h4>Mitspieler ({{ selectedPlayers.length }})</h4>
                <div class="players-list">
                  @for (player of selectedPlayers; track player.id) {
                    <span class="player-badge">{{ player.name }}</span>
                  }
                </div>
              </div>
            }
          </div>
        }

        <!-- Multi-player price breakdown (players selected, pricingPerPlayer, or guest slots with allowance) -->
        @if (selectedPlayers.length > 0 || isPricingPerPlayerEnabled() || getGuestSlotCount() > 0) {
          <div class="price-breakdown-card">
            <h3>Preisaufteilung</h3>

            @if (pricePreviewLoading) {
              <div class="loading-inline">
                <span class="spinner-small"></span>
                <span>Preise werden berechnet...</span>
              </div>
            } @else if (multiPlayerPricePreview && multiPlayerPricePreview.playerBreakdown.length > 0) {
              <div class="breakdown-table">
                @for (player of multiPlayerPricePreview.playerBreakdown; track $index) {
                  <div class="breakdown-row" [class.guest-slot]="player.isGuestSlot">
                    <div class="player-info">
                      <span class="player-name">
                        {{ player.userName }}
                        @if (player.isOrganizer) {
                          <span class="organizer-badge">(Du)</span>
                        }
                        @if (player.isGuestSlot) {
                          <span class="guest-badge">Gast</span>
                        }
                        @if (player.countsAsGuestUnit && !player.isGuestSlot) {
                          <span class="guest-badge">Gastgebühr</span>
                        }
                      </span>
                      @if (player.membershipAppliedName) {
                        <span class="membership-badge">{{ player.membershipAppliedName }}</span>
                      }
                      @if (player.countsAsGuestUnit && player.guestFee !== undefined) {
                        <span class="guest-fee-hint">Gastgebühr: {{ player.guestFee | currency:'EUR':'symbol':'1.2-2' }}</span>
                      }
                    </div>
                    <div class="player-price">
                      @if (player.savings > 0) {
                        <span class="base-price strikethrough">{{ player.basePriceShare | currency:'EUR':'symbol':'1.2-2' }}</span>
                        <span class="savings-badge">-{{ player.savings | currency:'EUR':'symbol':'1.2-2' }}</span>
                      }
                      <span class="final-price">{{ player.priceShare | currency:'EUR':'symbol':'1.2-2' }}</span>
                    </div>
                  </div>
                }

                <!-- Guest fee total (explicit line item) -->
                @if ((multiPlayerPricePreview.guestFeeTotal ?? 0) > 0) {
                  <div class="breakdown-row guest-fee-row">
                    <span class="total-label">Gastgebühren gesamt</span>
                    <span class="final-price">{{ multiPlayerPricePreview.guestFeeTotal | currency:'EUR':'symbol':'1.2-2' }}</span>
                  </div>
                }

                <!-- Stripe minimum-charge bump (visible BEFORE confirmation) -->
                @if ((multiPlayerPricePreview.minimumChargeAdjustment ?? 0) > 0) {
                  <div class="breakdown-row guest-fee-row">
                    <span class="total-label">Mindestbetrag</span>
                    <span class="final-price">+{{ multiPlayerPricePreview.minimumChargeAdjustment | currency:'EUR':'symbol':'1.2-2' }}</span>
                  </div>
                }

                <!-- Total row -->
                <div class="breakdown-row total-row">
                  <span class="total-label">Gesamtpreis</span>
                  <span class="total-price">{{ multiPlayerPricePreview.totalPrice | currency:'EUR':'symbol':'1.2-2' }}</span>
                </div>

                <!-- Remaining guest units after allowance-based pricing -->
                @if (multiPlayerPricePreview.remainingGuestUnits !== undefined) {
                  <div class="guest-units-summary">
                    Verbleibende Gasteinheiten: {{ multiPlayerPricePreview.remainingGuestUnits }}
                  </div>
                }

                <!-- Total savings indicator (when applicable) -->
                @if (multiPlayerPricePreview.totalSavings > 0) {
                  <div class="savings-summary">
                    <app-icon [type]="IconType.CHECK" [size]="16" class="savings-icon"></app-icon>
                    <span>Du sparst {{ multiPlayerPricePreview.totalSavings | currency:'EUR':'symbol':'1.2-2' }} durch Mitgliedschaften</span>
                  </div>
                }
              </div>
            } @else {
              <p class="no-breakdown-text">Preisberechnung nicht verfügbar</p>
            }
          </div>
        }

        <!-- User info (if logged in) -->
        @if (getCurrentUser(); as user) {
          <div class="user-info">
            <h3 class="section-title">Deine Daten</h3>
            <div class="user-detail">
              <span class="detail-label">Name</span>
              <span class="detail-value">{{ user.username }}</span>
            </div>
            <div class="user-detail">
              <span class="detail-label">E-Mail</span>
              <span class="detail-value">{{ user.email }}</span>
            </div>
          </div>
        }

        <!-- Error message -->
        @if (bookingError) {
          <div class="error-message">
            {{ bookingError }}
          </div>
        }
      </div>

      <!-- Preview Step Actions -->
      <div class="modal-actions">
        @if (showPlayersStep()) {
          <button type="button" class="btn btn-ghost btn-back" (click)="goBackToPlayers()">
            <app-icon [type]="IconType.ARROW_LEFT" [size]="18"></app-icon>
            Zurück
          </button>
        } @else {
          <button type="button" class="btn btn-ghost" (click)="onCancel()">Abbrechen</button>
        }
        <button type="button" class="btn btn-primary" [disabled]="isMultiPlayerPricingPending()" (click)="goToPaymentOrConfirm()">
          @if (pricePreviewLoading) {
            Preis wird berechnet…
          } @else if (isFullyCoveredByVouchers()) {
            Mit Gutschein buchen
          } @else {
            Weiter zur Zahlung
            <app-icon [type]="IconType.CHEVRON_RIGHT" [size]="18"></app-icon>
          }
        </button>
      </div>
    }

    <!-- ============================================================================
         STEP 3: Payment
         ============================================================================ -->
    @if (step() === 'payment') {
      <div class="modal-content">
        <!-- Payment summary (wrapper-owned: what is being paid + total; the
             voucher/remaining math lives in the payment section's ledger) -->
        <div class="payment-summary-card">
          <div class="payment-summary-text">
            <span class="payment-summary-label">Zahlungsübersicht</span>
            <span class="payment-summary-description">{{ getPaymentDescription() }}</span>
          </div>
          <span class="payment-summary-amount">{{ getEffectiveTotalPrice() | currency:'EUR':'symbol':'1.2' }}</span>
        </div>

        <!-- Payment section: vouchers + ledger + payment methods in one flow -->
        @if (heldSlot && getCurrentUser()) {
          <app-payment-section
            [totalPrice]="getEffectiveTotalPrice()"
            [organizationId]="getOrganizationId()"
            [categoryId]="getCategoryId()"
            [bookingHoldId]="heldSlot.id"
            [description]="getPaymentDescription()"
            [playerUserIds]="getPlayerUserIds()"
            [guestSlotCount]="getGuestSlotCount()"
            [onSitePaymentEnabled]="onSitePaymentEnabled"
            [stripePaymentEnabled]="stripePaymentEnabled"
            [sepaPaymentEnabled]="sepaPaymentEnabled"
            [paypalPaymentEnabled]="paypalPaymentEnabled"
            [paypalClientId]="paypalClientId"
            [paypalEnvironment]="paypalEnvironment"
            [voucherPaymentEnabled]="voucherPaymentEnabled"
            (paymentMethodChanged)="onPaymentMethodChanged($event)"
            (paymentSuccess)="onPaymentSuccess($event)"
            (paymentError)="onPaymentError($event)"
            (voucherCalculationChanged)="onVoucherCalculationChanged($event)"
            (fullyCoveredByVouchersChanged)="onFullyCoveredByVouchersChanged($event)"
            (selectedVoucherCodesChanged)="onSelectedVoucherCodesChanged($event)"
            [locked]="bookingInProgress"
            (voucherCalculationPendingChanged)="voucherCalculationPending.set($event)"
            (confirmFnReady)="onConfirmFnReady($event)"
            (paymentFormComplete)="onPaymentFormComplete($event)"
            (providerOwnsSubmit)="onProviderOwnsSubmit($event)">
          </app-payment-section>
        }

        <!-- Error message -->
        @if (bookingError) {
          <div class="error-message">
            {{ bookingError }}
          </div>
        }
      </div>

      <!-- Payment Step Actions -->
      <div class="modal-actions">
        <button type="button" class="btn btn-ghost btn-back" (click)="goBackToPreview()">
          <app-icon [type]="IconType.ARROW_LEFT" [size]="18"></app-icon>
          Zurück
        </button>
        <!-- PayPal renders its own button; ours must step aside rather than
             sit next to it offering a second, non-functional way to pay. -->
        @if (!isSubmitOwnedByProvider()) {
        <button type="submit" class="btn btn-primary" (click)="onSubmit()"
                [disabled]="isConfirmButtonDisabled()">
          @if (bookingInProgress) {
            <span class="spinner"></span>
            Wird verarbeitet...
          } @else if (!getCurrentUser()) {
            Anmelden um fortzufahren
          } @else if (isFullyCoveredByVouchers()) {
            Mit Gutschein buchen
          } @else {
            Buchung bestätigen · {{ getRemainingAmount() | currency:'EUR':'symbol':'1.2' }}
          }
        </button>
        }
      </div>
    }

    <!-- ============================================================================
         STEP 4: Success
         ============================================================================ -->
    @if (step() === 'success' && confirmedBooking) {
      <div class="modal-content">
        <div class="success-section">
          <div class="success-icon" aria-hidden="true">
            <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
              <polyline points="22 4 12 14.01 9 11.01"></polyline>
            </svg>
          </div>
          <h2>Erfolgreich gebucht!</h2>
          <p>Ihre Buchung wurde erfolgreich erstellt.</p>

          <div class="success-summary">
            <div class="summary-row">
              <span class="summary-label">Platz</span>
              <span class="summary-value">{{ confirmedBooking.categoryName }}: {{ confirmedBooking.courtName }}</span>
            </div>
            <div class="summary-row">
              <span class="summary-label">Datum</span>
              <span class="summary-value">{{ formatDateForSuccess(confirmedBooking.date) }}</span>
            </div>
            <div class="summary-row">
              <span class="summary-label">Uhrzeit</span>
              <span class="summary-value">{{ formatTime(confirmedBooking.startTime) }}</span>
            </div>
            <div class="summary-row">
              <span class="summary-label">Preis</span>
              <span class="summary-value price-highlight">{{ confirmedBooking.price | currency:'EUR':'symbol':'1.2' }}</span>
            </div>

            <!-- Players in success -->
            @if (confirmedBooking.players && confirmedBooking.players.length > 0) {
              <div class="players-summary">
                <h4>Mitspieler ({{ confirmedBooking.players.length }})</h4>
                <div class="players-list">
                  @for (player of confirmedBooking.players; track player.id) {
                    <span class="player-badge">{{ player.name }}</span>
                  }
                </div>
              </div>
            }
          </div>
        </div>
      </div>

      <!-- Success Actions -->
      <div class="modal-actions">
        <button type="button" class="btn btn-secondary" (click)="bookAnother()">Weitere Buchung</button>
        <button type="button" class="btn btn-primary" (click)="goToMyBookings()">Meine Buchungen</button>
      </div>
    }
  </div>
</div>
